export function compositeRatingId(ratedUserId, raterUserId) {
    return `${ratedUserId}_${raterUserId}`;
}
//# sourceMappingURL=rating.js.map